import { render } from "./MemberCardsUser.vue?vue&type=template&id=6cdac66a"
import script from "./MemberCardsUser.vue?vue&type=script&lang=js"
export * from "./MemberCardsUser.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__